import { breakpoints } from "../../tokens/size";
const defaultFontSize = {
    fontSize: '1.8rem',
    [`@media (min-width: ${breakpoints.xl})`]: {
        fontSize: '2rem',
    },
    [`@media (max-width: ${breakpoints.lg})`]: {
        fontSize: '1.8rem',
    },
    [`@media (max-width: ${breakpoints.sm})`]: {
        fontSize: '1.6rem',
    },
};
const smallFontSize = {
    fontSize: '1.4rem',
    lineHeight: '1.5',
    [`@media (min-width: ${breakpoints.xl})`]: {
        fontSize: '1.4rem',
    },
    [`@media (max-width: ${breakpoints.lg})`]: {
        fontSize: '1.4rem',
    },
    [`@media (max-width: ${breakpoints.sm})`]: {
        fontSize: '1.2rem',
    },
};
export const buttonStyles = {
    button: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 500,
        lineHeight: '1.5',
        minWidth: 0,
        textTransform: 'initial',
        borderRadius: '0.6rem',
        boxShadow: 'none',
        transition: 'color, box-shadow, border-color, background-color',
        transitionTimingFunction: 'ease',
        transitionDuration: '500ms',
        '&:hover': {
            boxShadow: 'none',
        },
        '&:focus': {
            boxShadow: 'none',
        },
    },
    ['variant-contained']: (paletteColor) => ({
        color: '#FFFFFF',
        backgroundColor: paletteColor,
        border: '1px solid',
        borderColor: paletteColor,
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0)',
            color: paletteColor,
            borderColor: 'currentColor',
        },
        '&:focus': {
            backgroundColor: 'rgba(255,255,255,0)',
            color: paletteColor,
            borderColor: 'currentColor',
        },
        '&[disabled]': {
            backgroundColor: '#C1C9D6',
            color: '#FFF',
            borderColor: '#C1C9D6',
        },
    }),
    ['variant-outlined']: (paletteColor) => ({
        color: paletteColor,
        backgroundColor: 'rgba(255,255,255,0)',
        borderColor: 'currentColor',
        '&:hover': {
            color: '#FFF',
            backgroundColor: paletteColor,
            borderColor: paletteColor,
        },
        '&:focus': {
            color: '#FFF',
            backgroundColor: paletteColor,
            borderColor: paletteColor,
        },
        '&[disabled]': {
            color: '#C1C9D6',
            backgroundColor: '#FFF',
            borderColor: '#C1C9D6',
        },
    }),
    ['variant-text']: (paletteColor) => ({
        padding: '0.6rem 0.8rem !important',
        color: paletteColor,
        border: '1px solid rgba(255,255,255, 0)',
        '&:hover': {
            backgroundColor: '#EAEDF1',
        },
        '&:focus': {
            borderColor: 'currentColor',
            backgroundColor: '#EAEDF1',
        },
        '&:focus > span:last-child': {
            opacity: 0.4,
        },
        '&[disabled]': {
            color: '#C1C9D6',
        },
    }),
    ['size-large']: Object.assign({ padding: '2rem 3rem !important' }, defaultFontSize),
    ['size-medium']: Object.assign({ padding: '1.6rem 2.6rem !important' }, defaultFontSize),
    ['size-small']: Object.assign({ padding: '1rem 1.4rem !important' }, smallFontSize),
    ['size-tiny']: Object.assign({ padding: '0.4rem 1.2rem !important' }, smallFontSize),
};
